import { Stack } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import type { CreateIntervalFormData } from "@sinch/components/application/RateInterval/CreateInterval/formSchema";
import { NumberInput, useMuiController } from "@sinch/components/index";

export const WorkedDurationSettings: FC = () => {
  const { t } = useTranslation();
  const { field: fromField } = useMuiController<CreateIntervalFormData, "settings.fromAmountOfHours">({
    name: "settings.fromAmountOfHours",
  });
  const { field: toField } = useMuiController<CreateIntervalFormData, "settings.toAmountOfHours">({
    name: "settings.toAmountOfHours",
  });

  return (
    <Stack spacing={2}>
      <NumberInput {...fromField} fullWidth label={t("RateUnit.durationFrom")} min={0} />
      <NumberInput {...toField} fullWidth label={t("RateUnit.durationTo")} min={fromField.value} />
    </Stack>
  );
};
